module.exports = __webpack_public_path__ + "static/media/career-handshake.13eb7ba1.svg";